import { Node, mergeAttributes } from '@tiptap/core';

const Column = Node.create({
  name: 'column',
  content: 'block+',
  isolating: true,
  defining: true,

  parseHTML() {
    return [{ tag: 'div.column' }];
  },

  renderHTML({ HTMLAttributes }) {
    return [
      'div',
      mergeAttributes({ class: 'column' }, HTMLAttributes),
      0,
    ];
  },
});

export default Column;
